import { Component, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { InputNumberModule } from 'primeng/inputnumber';

interface NumberTypeProps {
  label?: string;
  max?: number;
  min?: number;
  mode?: string;
  currency?: string;
  locale?: string;
  useGrouping?: boolean;
  suffix?: string;
  prefix?: string;
}

@Component({
  selector: 'app-number-type',
  imports: [
    ReactiveFormsModule, FormlyModule, InputNumberModule
  ],
  templateUrl: './number-type.type.html',
  styleUrl: './number-type.type.scss',
})
export class NumberType extends FieldType<FieldTypeConfig> implements OnInit {

  ngOnInit() {
  }

  private get customProps(): NumberTypeProps {
    return this.props as NumberTypeProps;
  }

  get inputMode(): string {
    return this.customProps.mode ?? 'decimal';
  }

  get inputCurrency(): string | undefined {
    // Solo retornar currency cuando el modo es 'currency'
    return this.inputMode === 'currency' ? this.customProps.currency : undefined;
  }

  get inputLocale(): string {
    // Siempre usar locale para que el separador decimal sea coma
    return this.customProps.locale ?? 'es-AR';
  }

  get inputUseGrouping(): boolean {
    return this.customProps.useGrouping ?? true;
  }

  get minFractionDigits(): number {
    return this.inputMode === 'currency' ? 2 : 0;
  }

  get maxFractionDigits(): number {
    return 2;
  }

  get inputSuffix(): string | undefined {
    return this.customProps.suffix;
  }

  get inputPrefix(): string | undefined {
    return this.customProps.prefix;
  }
}
